import React, {PropsWithChildren, useEffect, useRef} from "react";
import ReactDOM from 'react-dom';
import "./OverlayModal.scss"

interface OverlayModalProps extends PropsWithChildren {
    onCloseModal?: () => void;
}

export const OverlayModal: React.FunctionComponent<OverlayModalProps> = (props) => {
    const modalRef = useRef<HTMLDivElement>() as any;

    useEffect(() => {
        if (modalRef && props.onCloseModal) {
            (modalRef.current as HTMLDivElement).addEventListener('click', (event: MouseEvent) => {
                if (event.currentTarget == event.target) {
                    props.onCloseModal?.();
                }
            });
        }
    }, [modalRef]);

    useEffect(() => {
        const previousBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        return () => {
            document.body.style.overflow = previousBodyOverflow;
        };
    }, [false]);

    const getModalLayout = () => {
        return <div className='overlay-modal' ref={modalRef}>
            <div className='overlay-modal-content'>
                {props.children}
            </div>
        </div>
    }
    return ReactDOM.createPortal(getModalLayout(), document.body);
}